import React from 'react';
import NextLink from 'next/link';
import { usePathname as useNextPathname, useParams as useNextParams } from 'next/navigation';
import { createSharedPathnamesNavigation } from 'next-intl/navigation';

export const locales = ['en', 'hi'] as const;
export const localePrefix = 'as-needed';

const sharedNav = createSharedPathnamesNavigation({
  locales,
  localePrefix
});

export const { redirect, usePathname, useRouter } = sharedNav;

export const Link = React.forwardRef<HTMLAnchorElement, any>(function LocalizedLink(
  { href, ...props },
  ref
) {
  let locale = 'en';
  try {
    if (typeof useNextParams === 'function') {
      const params = useNextParams();
      if (params && (params as any).locale) {
        locale = (params as any).locale;
      }
    }
    if (locale === 'en' && typeof useNextPathname === 'function') {
      const pathname = useNextPathname();
      if (pathname === '/hi' || pathname?.startsWith('/hi/')) {
        locale = 'hi';
      }
    }
  } catch (_) {}

  let finalHref = href;
  if (typeof href === 'string' && href.startsWith('/')) {
    if (locale === 'hi' && !href.startsWith('/hi')) {
      finalHref = href === '/' ? '/hi' : `/hi${href}`;
    }
  }

  return React.createElement(NextLink, { ref, href: finalHref, ...props });
});
